import { render } from "./DeleteDishModalComponent.vue?vue&type=template&id=771a2862&scoped=true"
import script from "./DeleteDishModalComponent.vue?vue&type=script&lang=js"
export * from "./DeleteDishModalComponent.vue?vue&type=script&lang=js"

import "./DeleteDishModalComponent.vue?vue&type=style&index=0&id=771a2862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771a2862"]])

export default __exports__